import Wix from './wix-sdk-polyfill';

const getUserPrivacyStatus = cb => Wix.currentMember(
  member => {
    if (!member) {
      return cb(undefined);
    }

    const { attributes } = member.data || member;

    console.info(`privacyStatus: ${attributes.privacyStatus}`);
    cb(attributes.privacyStatus);
  }
);

export default getUserPrivacyStatus;



// WEBPACK FOOTER //
// ./app/services/get-user-privacy-status.js